import { Autocomplete, Grid, TextField } from "@mui/material";
import type { WithDbId } from "adl-gen/common/db";
import type { StorageLocation } from "adl-gen/ferovinum/app/db";
import { BaseWizardCard } from "components/library/widgets/wizard-card/base-wizard-card";
import type { FC } from "react";

interface LocationSelectorCardProps {
  selectedLocation?: WithDbId<StorageLocation>;
  storageLocations: WithDbId<StorageLocation>[];
  onChange: (v: WithDbId<StorageLocation> | null) => Promise<void>;
}
export const LocationSelectorCard = ({
  selectedLocation,
  storageLocations,
  onChange,
}: LocationSelectorCardProps) => {
  return (
    <BaseWizardCard
      title={"Storage Location"}
      subtitle={
        "Please select the storage location from where your products are to be sold, or where your finished products will be produced."
      }
      inputElement={
        <Grid container spacing={0}>
          <Grid item xs={12} lg={5} pl={0}>
            <LocationInput
              selectedLocation={selectedLocation}
              locations={storageLocations}
              onChange={onChange}
            />
          </Grid>
        </Grid>
      }
    />
  );
};

const LocationInput: FC<{
  selectedLocation?: WithDbId<StorageLocation>;
  locations: WithDbId<StorageLocation>[];
  onChange: (v: WithDbId<StorageLocation> | null) => void;
}> = ({ selectedLocation, locations, onChange }) => {
  return (
    <Autocomplete<WithDbId<StorageLocation>>
      fullWidth
      value={selectedLocation ?? null}
      onChange={(_e, value) => onChange(value)}
      getOptionLabel={(loc: WithDbId<StorageLocation>) =>
        loc.value.locationName || ""
      }
      options={locations}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select storage location"
          name="location"
          required
        />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};
